import { Injectable } from '@angular/core';
import {
  ChangeLauncherHiddenFlagGQL,
  LauncherStateChangeInput,
  ChangeLauncherAdvancedFeaturesGQL,
} from '../../members.api.g';
import { map } from 'rxjs/operators';
import { MaintenanceGQL } from 'src/app/members.api.g';
import { BehaviorSubject } from 'rxjs';
import { HttpClient } from '@angular/common/http';
@Injectable({
  providedIn: 'root',
})
export class LauncherService {
  constructor(
    private changeLauncherHiddenFlagGQL: ChangeLauncherHiddenFlagGQL,
    private ChangeLauncherAdvancedFeaturesGQL: ChangeLauncherAdvancedFeaturesGQL
  ) {}

  switchLauncherState(launcherStateInput: LauncherStateChangeInput) {
    return this.changeLauncherHiddenFlagGQL
      .mutate({ input: launcherStateInput })
      .pipe(map((res) => res.data.launcher.changeLauncherHiddenFlag));
  }

  switchChangeLauncherAdvancedFeatures(launcherStateInput: LauncherStateChangeInput) {
    return this.ChangeLauncherAdvancedFeaturesGQL.mutate({ input: launcherStateInput }).pipe(
      map((res) => res.data.launcher.changeLauncherAdvancedFeatures)
    );
  }
}

@Injectable({
  providedIn: 'root',
})
export class LauncherConfigService {
  private _config: any = null;
  private _config$ = new BehaviorSubject<any>(null);
  private _isAdmin: boolean = false;
  private _adminBypassedMaintenance$ = new BehaviorSubject<boolean>(
    localStorage.getItem('adminBypassedMaintenance') === 'true'
  );
  constructor(private MaintenanceGQL: MaintenanceGQL, private http: HttpClient) {}

  loadConfig(path: string): void {
    this.http
      .get<AppShellLauncher>(window.__CONFIG?.API_URL + '/api/launcher/maintenance', {
        params: { launcherPath: path },
      })
      .subscribe({
        next: (launcher) => {
          const configJson = launcher?.additionalConfiguration;
          this._config = configJson ? JSON.parse(configJson) : null;
          const adminJson = launcher?.isAdmin;
          this._isAdmin = !!adminJson;
          this._config$.next(this._config);
        },
        error: (err) => {
          this._config = null;
          this._isAdmin = false;
          this._config$.next(null);
        },
      });
  }
  get config(): any {
    return this._config;
  }

  get config$() {
    return this._config$.asObservable();
  }

  get isAdmin(): boolean {
    return this._isAdmin;
  }

  get adminBypassedMaintenance$() {
    return this._adminBypassedMaintenance$.asObservable();
  }

  setAdminBypass(value: boolean) {
    if (this._adminBypassedMaintenance$.getValue() === value) {
      return;
    }

    localStorage.setItem('adminBypassedMaintenance', value.toString());
    this._adminBypassedMaintenance$.next(value);
  }
  resetAdminBypass() {
    localStorage.removeItem('adminBypassedMaintenance');
    this.setAdminBypass(false);
  }
}
export interface AppShellLauncher {
  id?: string;
  path?: string;
  isHidden?: boolean;
  defaultHiddenValue?: boolean;
  isAdmin?: boolean;
  additionalConfiguration?: string;
}
